var map = {
	"./en-hk/backend.json": 82802,
	"./en-hk/cart.json": 46004,
	"./en-hk/checkout.json": 73465,
	"./en-hk/common.json": 61610,
	"./en-hk/landing-page.json": 45906,
	"./en-hk/onboarding.json": 57938,
	"./en-hk/orders.json": 38942,
	"./en-hk/portal.json": 81424,
	"./en-hk/product.json": 15856,
	"./en-hk/registration.json": 18642,
	"./en-hk/retailer.json": 86321,
	"./en-hk/rewards.json": 28478,
	"./en-hk/search.json": 14540,
	"./en-hk/strapi-brand-[brandKey].json": 53563,
	"./en-hk/strapi-brand-embed-widget-.json": 36673,
	"./en-hk/strapi-brand-registration-confirmation.json": 18783,
	"./en-hk/strapi-brand-registration.json": 59282,
	"./en-hk/strapi-component-app-header.json": 18518,
	"./en-hk/strapi-home.json": 81683,
	"./en-hk/strapi-portal-finances.json": 63810,
	"./en-hk/strapi-portal-products.json": 49593,
	"./en-hk/strapi-portal-settings.json": 34804,
	"./en-hk/strapi-retailer-orders-[key]-issues-report.json": 67042,
	"./en-hk/strapi-retailer-orders-[key]-return-request.json": 67350,
	"./en-hk/strapi-retailer-orders.json": 47807,
	"./en-hk/strapi-retailer-returns.json": 5317,
	"./en-hk/strapi-retailer-settings-upload-documents.json": 16345,
	"./en-hk/strapi-retailer.json": 93528,
	"./en-hk/strapi-search-[...term].json": 24399,
	"./en-hk/test.json": 27441,
	"./en-my/backend.json": 60701,
	"./en-my/cart.json": 45618,
	"./en-my/checkout.json": 27541,
	"./en-my/common.json": 36311,
	"./en-my/landing-page.json": 2276,
	"./en-my/onboarding.json": 87861,
	"./en-my/orders.json": 96112,
	"./en-my/portal.json": 61518,
	"./en-my/product.json": 1239,
	"./en-my/registration.json": 92063,
	"./en-my/retailer.json": 84751,
	"./en-my/rewards.json": 12650,
	"./en-my/search.json": 6518,
	"./en-my/strapi-brand-[brandKey].json": 71536,
	"./en-my/strapi-brand-embed-widget-.json": 96579,
	"./en-my/strapi-brand-registration-confirmation.json": 51479,
	"./en-my/strapi-brand-registration.json": 36665,
	"./en-my/strapi-component-app-header.json": 54269,
	"./en-my/strapi-home.json": 5832,
	"./en-my/strapi-portal-finances.json": 40504,
	"./en-my/strapi-portal-products.json": 61796,
	"./en-my/strapi-portal-settings.json": 66411,
	"./en-my/strapi-retailer-orders-[key]-issues-report.json": 19755,
	"./en-my/strapi-retailer-orders-[key]-return-request.json": 67226,
	"./en-my/strapi-retailer-orders.json": 8273,
	"./en-my/strapi-retailer-returns.json": 73374,
	"./en-my/strapi-retailer-settings-upload-documents.json": 52636,
	"./en-my/strapi-retailer.json": 68425,
	"./en-my/strapi-search-[...term].json": 30157,
	"./en-sg/backend.json": 24848,
	"./en-sg/cart.json": 83182,
	"./en-sg/checkout.json": 39743,
	"./en-sg/common.json": 53480,
	"./en-sg/landing-page.json": 63952,
	"./en-sg/onboarding.json": 25150,
	"./en-sg/orders.json": 35005,
	"./en-sg/portal.json": 95727,
	"./en-sg/product.json": 63182,
	"./en-sg/registration.json": 42524,
	"./en-sg/retailer.json": 57511,
	"./en-sg/rewards.json": 6847,
	"./en-sg/search.json": 4554,
	"./en-sg/strapi-brand-[brandKey].json": 76255,
	"./en-sg/strapi-brand-embed-widget-.json": 30681,
	"./en-sg/strapi-brand-registration-confirmation.json": 36295,
	"./en-sg/strapi-brand-registration.json": 69501,
	"./en-sg/strapi-component-app-header.json": 21137,
	"./en-sg/strapi-home.json": 8725,
	"./en-sg/strapi-portal-finances.json": 75335,
	"./en-sg/strapi-portal-products.json": 7759,
	"./en-sg/strapi-portal-settings.json": 65278,
	"./en-sg/strapi-retailer-orders-[key]-issues-report.json": 68439,
	"./en-sg/strapi-retailer-orders-[key]-return-request.json": 20473,
	"./en-sg/strapi-retailer-orders.json": 38249,
	"./en-sg/strapi-retailer-returns.json": 39643,
	"./en-sg/strapi-retailer-settings-upload-documents.json": 97820,
	"./en-sg/strapi-retailer.json": 96865,
	"./en-sg/strapi-search-[...term].json": 58674,
	"./en-sg/test.json": 15202,
	"./en/backend.json": 78110,
	"./en/cart.json": 99012,
	"./en/checkout.json": 64811,
	"./en/common.json": 40464,
	"./en/landing-page.json": 61186,
	"./en/onboarding.json": 42002,
	"./en/orders.json": 5726,
	"./en/portal.json": 35788,
	"./en/product.json": 24693,
	"./en/registration.json": 6424,
	"./en/retailer.json": 86284,
	"./en/rewards.json": 90976,
	"./en/search.json": 17842,
	"./en/strapi-brand-[brandKey].json": 5946,
	"./en/strapi-brand-embed-widget-.json": 69213,
	"./en/strapi-brand-registration-confirmation.json": 22976,
	"./en/strapi-brand-registration.json": 11463,
	"./en/strapi-component-app-header.json": 67193,
	"./en/strapi-home.json": 35028,
	"./en/strapi-portal-finances.json": 16158,
	"./en/strapi-portal-products.json": 44940,
	"./en/strapi-portal-settings.json": 74239,
	"./en/strapi-retailer-orders-[key]-issues-report.json": 24667,
	"./en/strapi-retailer-orders-[key]-return-request.json": 60960,
	"./en/strapi-retailer-orders.json": 54543,
	"./en/strapi-retailer-returns.json": 82522,
	"./en/strapi-retailer-settings-upload-documents.json": 8147,
	"./en/strapi-retailer.json": 52962,
	"./en/strapi-search-[...term].json": 64509,
	"./en/test.json": 84839,
	"./sc/backend.json": 17687,
	"./sc/cart.json": 28482,
	"./sc/checkout.json": 80265,
	"./sc/common.json": 35884,
	"./sc/landing-page.json": 62330,
	"./sc/onboarding.json": 17649,
	"./sc/orders.json": 9154,
	"./sc/portal.json": 16983,
	"./sc/product.json": 79287,
	"./sc/registration.json": 71712,
	"./sc/retailer.json": 79961,
	"./sc/search.json": 91642,
	"./sc/strapi-brand-[brandKey].json": 22886,
	"./sc/strapi-brand-embed-widget-.json": 49137,
	"./sc/strapi-brand-registration-confirmation.json": 5027,
	"./sc/strapi-brand-registration.json": 85623,
	"./sc/strapi-component-app-header.json": 5123,
	"./sc/strapi-home.json": 23005,
	"./sc/strapi-portal-finances.json": 45665,
	"./sc/strapi-portal-products.json": 68215,
	"./sc/strapi-portal-settings.json": 25360,
	"./sc/strapi-retailer-orders-[key]-issues-report.json": 64291,
	"./sc/strapi-retailer-orders-[key]-return-request.json": 79193,
	"./sc/strapi-retailer-orders.json": 4330,
	"./sc/strapi-retailer-returns.json": 66194,
	"./sc/strapi-retailer-settings-upload-documents.json": 69375,
	"./sc/strapi-retailer.json": 83127,
	"./sc/strapi-search-[...term].json": 85669,
	"./sc/test.json": 76465,
	"./zh-hk/backend.json": 51377,
	"./zh-hk/cart.json": 50044,
	"./zh-hk/checkout.json": 52368,
	"./zh-hk/common.json": 69042,
	"./zh-hk/landing-page.json": 64593,
	"./zh-hk/onboarding.json": 63112,
	"./zh-hk/orders.json": 96596,
	"./zh-hk/portal.json": 67675,
	"./zh-hk/product.json": 76112,
	"./zh-hk/registration.json": 11085,
	"./zh-hk/retailer.json": 27368,
	"./zh-hk/rewards.json": 18134,
	"./zh-hk/search.json": 65331,
	"./zh-hk/strapi-brand-[brandKey].json": 3770,
	"./zh-hk/strapi-brand-embed-widget-.json": 71791,
	"./zh-hk/strapi-brand-registration-confirmation.json": 90200,
	"./zh-hk/strapi-brand-registration.json": 9015,
	"./zh-hk/strapi-component-app-header.json": 54363,
	"./zh-hk/strapi-home.json": 31441,
	"./zh-hk/strapi-portal-finances.json": 50898,
	"./zh-hk/strapi-portal-products.json": 33308,
	"./zh-hk/strapi-portal-settings.json": 70784,
	"./zh-hk/strapi-retailer-orders-[key]-issues-report.json": 87081,
	"./zh-hk/strapi-retailer-orders-[key]-return-request.json": 97247,
	"./zh-hk/strapi-retailer-orders.json": 54618,
	"./zh-hk/strapi-retailer-returns.json": 11162,
	"./zh-hk/strapi-retailer-settings-upload-documents.json": 80589,
	"./zh-hk/strapi-retailer.json": 51194,
	"./zh-hk/strapi-search-[...term].json": 36562,
	"./zh-hk/test.json": 99219,
	"./zh-my/backend.json": 37489,
	"./zh-my/cart.json": 25187,
	"./zh-my/checkout.json": 37559,
	"./zh-my/common.json": 88871,
	"./zh-my/landing-page.json": 44933,
	"./zh-my/onboarding.json": 52903,
	"./zh-my/orders.json": 89563,
	"./zh-my/portal.json": 87262,
	"./zh-my/product.json": 30364,
	"./zh-my/registration.json": 39872,
	"./zh-my/retailer.json": 32972,
	"./zh-my/rewards.json": 2551,
	"./zh-my/search.json": 53999,
	"./zh-my/strapi-brand-[brandKey].json": 68492,
	"./zh-my/strapi-brand-embed-widget-.json": 65511,
	"./zh-my/strapi-brand-registration-confirmation.json": 60079,
	"./zh-my/strapi-brand-registration.json": 95751,
	"./zh-my/strapi-component-app-header.json": 60846,
	"./zh-my/strapi-home.json": 85027,
	"./zh-my/strapi-portal-finances.json": 27184,
	"./zh-my/strapi-portal-products.json": 12593,
	"./zh-my/strapi-portal-settings.json": 84223,
	"./zh-my/strapi-retailer-orders-[key]-issues-report.json": 45603,
	"./zh-my/strapi-retailer-orders-[key]-return-request.json": 64603,
	"./zh-my/strapi-retailer-orders.json": 98266,
	"./zh-my/strapi-retailer-returns.json": 41443,
	"./zh-my/strapi-retailer-settings-upload-documents.json": 14761,
	"./zh-my/strapi-retailer.json": 76950,
	"./zh-my/strapi-search-[...term].json": 8327,
	"./zh-sg/backend.json": 19875,
	"./zh-sg/cart.json": 29540,
	"./zh-sg/checkout.json": 27867,
	"./zh-sg/common.json": 25520,
	"./zh-sg/landing-page.json": 14313,
	"./zh-sg/onboarding.json": 73446,
	"./zh-sg/orders.json": 70346,
	"./zh-sg/portal.json": 25156,
	"./zh-sg/product.json": 88479,
	"./zh-sg/registration.json": 67847,
	"./zh-sg/retailer.json": 95415,
	"./zh-sg/rewards.json": 77825,
	"./zh-sg/search.json": 51906,
	"./zh-sg/strapi-brand-[brandKey].json": 4623,
	"./zh-sg/strapi-brand-embed-widget-.json": 41113,
	"./zh-sg/strapi-brand-registration-confirmation.json": 535,
	"./zh-sg/strapi-brand-registration.json": 27513,
	"./zh-sg/strapi-component-app-header.json": 93815,
	"./zh-sg/strapi-home.json": 55747,
	"./zh-sg/strapi-portal-finances.json": 92775,
	"./zh-sg/strapi-portal-products.json": 48135,
	"./zh-sg/strapi-portal-settings.json": 2394,
	"./zh-sg/strapi-retailer-orders-[key]-issues-report.json": 60358,
	"./zh-sg/strapi-retailer-orders-[key]-return-request.json": 5408,
	"./zh-sg/strapi-retailer-orders.json": 22653,
	"./zh-sg/strapi-retailer-returns.json": 55627,
	"./zh-sg/strapi-retailer-settings-upload-documents.json": 79673,
	"./zh-sg/strapi-retailer.json": 97963,
	"./zh-sg/strapi-search-[...term].json": 21201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56848;